import styled, { css } from "styled-components";
import { colors, grid_breakpoints } from "../../../../../theme/theme";

export const OrderDetailsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0 40px 24px 17px;
`;

export const OrderDetailsTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 24px;
	justify-content: space-between;

	em {
		color: ${colors.greyscale.darker_grey};
		font-size: 32px;
	}

	h1 {
		color: ${colors.greyscale.darker_grey};
		margin: 0;
		font-size: 24px;
		line-height: 1;
	}

	.status {
		display: flex;
		align-items: center;

		gap: 16px;

		.p-dropdown-label {
			line-height: 1;
			padding: 8px 16px;
		}
	}
`;

export const BackButton = styled.button`
	border: 0;
	background: transparent;
	border-radius: 50%;
	display: flex;
	align-items: center;
	cursor: pointer;
`;

export const OrderDetailsBody = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-areas:
		"client-info payment-info"
		"products-info products-info";
	gap: 24px 40px;
	font-size: 14px;

	> div {
		display: grid;
		grid-template-rows: 24px 1fr 40px;
		gap: 16px;

		border-radius: 8px;
		border: 1px solid ${colors.greyscale.grey};
		padding: 16px;

		h3 {
			font-size: 18px;
			font-weight: bold;
		}

		.info {
			display: grid;
			grid-template-columns: 1fr 1fr;
			gap: 8px 24px;
		}

		.label {
			color: ${colors.greyscale.darker_grey};
		}

		.value {
			color: ${colors.greyscale.black};
			display: flex;
			justify-content: space-between;
		}
	}

	@media (max-width: ${grid_breakpoints.md}) {
		grid-template-columns: 1fr;
		grid-template-areas:
			"client-info"
			"payment-info"
			"products-info";
	}
`;

export const ClientInfo = styled.div`
	grid-area: client-info;

	.status {
		display: flex;
		align-items: center;

		gap: 16px;
	}

	.p-dropdown-label {
		line-height: 1;
		padding: 8px 16px;
	}
`;

export const PaymentInfo = styled.div`
	grid-area: payment-info;

	.invoice {
		display: flex;
		align-items: center;
		gap: 16px;
		line-height: 1;
		width: 100%;
	}

	.actions{
		cursor: pointer;
	}
`;
export const ProductsInfo = styled.div`
	grid-area: products-info;
	display: flex !important;
`;

export const NotInformed = styled.div`
	color: ${colors.greyscale.dark_grey};
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 22px;
`;
export const DiscountField = styled.div`
	color: ${colors.primary.forest};
`;

export const StatusField = styled.div<any>`
	display: flex;
	padding: 4px 8px;
	justify-content: center;
	align-items: center;
	gap: 8px;
	border-radius: 2px;
	text-align: center;
	font-size: 10px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;

	margin-bottom: 20px;

	${(props) => {
		switch (props.status) {
			case 2:
				return css`
					background: #FFE9D6;
					color: #B65C12;
				`;
			case 5:
				return css`
					background: #EBECF9;
					color: #505CCC;
				`;
			case 3:
				return css`
					background: #FFF3F0;
					color: #943C28;
				`;
			case 4:
				return css`
					background: #F0FFFA;
					color: #28946E;
				`;
			default:
				return css`
					background: #f8f8f8;
					color: ${colors.greyscale.darker_grey};
				`;
		}
	}}
`;


export const ModalStyled = styled.div`
	/deep/ .modal-body{
		overflow: none !important;
	}
`